module.exports = __webpack_public_path__ + "img/login-v2-dark.8ec7c8a3.svg";